import React, { useCallback } from "react";
import { DialogActions } from "@material-ui/core";
import { useFormikContext } from "formik";

import { useSubmitHandler } from "components/Form/FormikControls";
import { Button, SecondaryButton } from "components/Form";
import { TransactionalSaleFormTabId } from "../constants";
import { MobileTransactionalCreateSaleFormValues } from "../lib/types";

interface ActionsProps {
  onClose: () => void;
  activeTab: TransactionalSaleFormTabId;
  changeTab: (id: TransactionalSaleFormTabId) => void;
  tabOrder: TransactionalSaleFormTabId[];
  isContextSubmitting?: boolean;
}

export const Actions = ({
  onClose,
  activeTab,
  changeTab,
  tabOrder,
  isContextSubmitting = false,
}: ActionsProps) => {
  const { submitForm } = useFormikContext<MobileTransactionalCreateSaleFormValues>();

  const [isSubmitEnabled, setIsSubmitEnabled] = React.useState(false);
  useSubmitHandler(false, setIsSubmitEnabled);

  const currentTabIndex = tabOrder.indexOf(activeTab);
  const isLastTab = currentTabIndex === tabOrder.length - 1;
  const isFirstTab = currentTabIndex === 0;

  const handleNext = useCallback(() => {
    changeTab(tabOrder[currentTabIndex + 1]);
  }, [currentTabIndex, changeTab, tabOrder]);

  const handleBack = useCallback(() => {
    changeTab(tabOrder[currentTabIndex - 1]);
  }, [currentTabIndex, changeTab, tabOrder]);

  const buttonStyle = { minHeight: 44 };

  return (
    <DialogActions>
      <SecondaryButton
        onClick={isFirstTab ? onClose : handleBack}
        inline
        border={false}
        style={buttonStyle}
      >
        {isFirstTab ? "Close" : "Back"}
      </SecondaryButton>
      {!isLastTab && (
        <SecondaryButton
          onClick={submitForm}
          disabled={isContextSubmitting || !isSubmitEnabled}
          inline
          style={buttonStyle}
        >
          Save & Close
        </SecondaryButton>
      )}
      {!isLastTab && (
        <Button
          onClick={handleNext}
          disabled={false}
          inline
          style={buttonStyle}
        >
          Next
        </Button>
      )}
      {isLastTab && (
        <Button
          onClick={submitForm}
          disabled={isContextSubmitting || !isSubmitEnabled}
          inline
          style={buttonStyle}
        >
          Save & Close
        </Button>
      )}
    </DialogActions>
  );
};
